export const experienceData = [
  {
    id: 1,
    company: "",
    jobtitle:
      "Trening MDM & Ćwiczenia w Rozejściu Mięśni Brzucha (Kasia Witek-Sokołowska)",
    startYear: "",
    endYear: "",
  },
  {
    id: 2,
    company: "",
    jobtitle:
      "Mobilność, stabilność, wzorce ruchowe CCS (Mariusz Dzięcioł&Konrad Topolski)",
    startYear: "",
    endYear: "",
  },
  {
    id: 4,
    company: "",
    jobtitle: "Programowanie treningowe CSS (Konrad Topolski&Mariusz Czerw)",
    startYear: "",
    endYear: "",
  },
  {
    id: 4,
    company: "",
    jobtitle: "Budowanie pośladków CCS (Mariusz Dzięcioł&Konrad Topolski)",
    startYear: "",
    endYear: "",
  },
  {
    id: 5,
    company: "",
    jobtitle: "Bezpieczny trening w ciąży (Kasia Witek-Sokołowska)",
    startYear: "",
    endYear: "",
  },
  {
    id: 6,
    company: "",
    jobtitle: "Maceball",
    startYear: "",
    endYear: "",
  },
  {
    id: 7,
    company: "",
    jobtitle: "Kettlebell 101 Strong First",
    startYear: "",
    endYear: "",
  },
  {
    id: 8,
    company: "",
    jobtitle: "CrossFit lvl 1",
    startYear: "",
    endYear: "",
  },
];
